// Types
import { AppDispatch, AppGetState } from 'types/RootState.types';

// Config
import { GET_OCP_HEADERS, URL_BROWSER_DATA } from '@constants/endpointConstants';

export const sendBrowserData = () => async (_dispatch: AppDispatch, getState: AppGetState) => {
  const url = `/bff/${URL_BROWSER_DATA}`;
  const state = getState();
  const headers = GET_OCP_HEADERS(state);

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });

    const html = await response.text();
    return html;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Error fetching browser data:', error);
    return '';
  }
};
